import { IPromotion } from './Promotion';
import { ImageWithMetadata } from './Image';

export class PromotionCarouselItem {
    public id: number;

    public heading: string;

    public itemIds: Set<string>;

    public promotions: IPromotion[];

    public defaultPromotions: IPromotion[];

    public maxOffers: number;

    constructor(id: number, heading: string, promotions: IPromotion[], itemIds: string[], defaultPromotions?: IPromotion[]) {
        this.id = id;
        this.heading = heading;
        this.promotions = promotions;
        this.itemIds = new Set(itemIds) || new Set([]);
        this.defaultPromotions = defaultPromotions || [];
        this.maxOffers = 3;
    }

    setDefaultPromotions(promotions: any[]) {
        this.defaultPromotions = promotions.map((p: any) => {
            const promo = {
                id: p.id,
                price: p.price || '',
                productName: p.productName || '',
                saleEndDate: p.salesEndDate || '',
                type: p.type,
                productDescription: p.productDescription || '',
                productImage: p.productImage || new ImageWithMetadata(0, 0, '', ''),
                productUpc: p.productUpc || '000000000000',
                baseIngredientId: p.baseIngredientId || -1,
                uniqueId: Math.random(),
                maxOffers: p.maxOffers || 3,
            } as IPromotion;
            if (promo.baseIngredientId > -1) {
                this.itemIds.add(promo.baseIngredientId.toString());
            }
            return promo;
        });
    }
}
